// Modul zur Erfassung von Personalkosten mit Personalkostentabelle
"use strict";

import CoreModels from "dias/core/models";
import foerdermoduleRegistry from "dias/foerderantrag/foerdermodule";
import controller from "./controller";
import template from "./template.jade";
import FoerderantragModels from "dias/foerderantrag/models";

import builder from "dias/standard_foerdermodule/utils/builder";


const personalkosten_lohnjournal = angular.module("dias.kosten_finanzierung.modul.personalkosten_lohnjournal", [
  CoreModels.name,
  foerdermoduleRegistry.name,
  FoerderantragModels.name,
]);

personalkosten_lohnjournal.config(/*@ngInject*/ FoerdermoduleRegistryProvider => {
  FoerdermoduleRegistryProvider.register("personalkosten_lohnjournal", "modul-personalkosten-lohnjournal");
})

  .directive("modulPersonalkostenLohnjournal", builder.directive(template, controller));

export default personalkosten_lohnjournal;
